import React from "react";
import PropTypes from "prop-types";

import Aside from "src/app/components/Aside/Aside";
import Main from "src/app/components/Main/Main";
import Card from "../../components/Card/Card";
import ContentElements from "../../components/ContentElements";
import AsideSearch from "../../components/AsideSearch/AsideSearch";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import ViewRelatedQuestions from "../../components/ViewRelatedQuestions/ViewRelatedQuestions";
import HelpTopics from "../../components/HelpTopics/HelpTopics";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";

// eslint-disable-next-line complexity
const FaqAnswer = ({ content = {} }) => {
  const {
    "body": { elements = [] } = {},
    "related-articles": relatedArticles = {},
  } = content.main || {};
  const relatedArticlesElements = relatedArticles.elements || [];
  const {
    topics,
    "search-box": searchBox,
    "get-in-touch": getInTouch,
  } = content.aside || {};

  const showGetInTouch =
    getInTouch && getInTouch.elements && getInTouch.elements.length > 0;

  return (
    <ErrorBoundary>
      <Main>
        <Card type="main">
          {elements.length > 0 &&
            elements.map((element, i) => (
              <ContentElements
                key={`${element.type}-${i}`}
                element={element}
                analytics={content.analytics}
              />
            ))}
        </Card>
        {relatedArticlesElements.length > 0 &&
          relatedArticlesElements[0].articles &&
          relatedArticlesElements[0].articles.length > 0 && (
            <Card type="bottom" ariaLive="polite" ariaRelevant="additions text">
              <ViewRelatedQuestions
                data={relatedArticlesElements[0]}
                button={
                  relatedArticlesElements[0].header &&
                  relatedArticlesElements[0].header.button
                }
                analytics={content.analytics}
              />
            </Card>
          )}
      </Main>
      <Aside>
        {topics && topics.elements && topics.elements.length > 0 && (
          <Card type="aside">
            <HelpTopics data={topics} />
          </Card>
        )}
        {searchBox && searchBox.elements && searchBox.elements.length > 0 && (
          <Card type="aside">
            <AsideSearch data={searchBox.elements[0]} />
          </Card>
        )}
        {showGetInTouch && (
          <Card type="aside" data-id="getInTouch">
            <GetInTouch data={getInTouch.elements[0]} />
          </Card>
        )}
      </Aside>
    </ErrorBoundary>
  );
};

FaqAnswer.defaultName = "FaqAnswer";

export default FaqAnswer;

FaqAnswer.propTypes = {
  content: PropTypes.object,
};
